<div class="main-container">
  @if (_taxonomiesCards().length>0) {

  <div class="page-top-section">
    <div class="search-container">
      <img src="assets/icons/taxonomy_search.svg" alt="search-icon">
      <input class="search-input" placeholder="Search by name" type="text" (input)="onSearchChange($event)">
    </div>
    <button class="btn-create-taxonomy" (click)="handleOpenNamePopup()">
      <img src="assets/icons/add-white.svg" alt="add-icon">
      <div class="btn-text">
        Create
      </div>
    </button>

  </div>
  }
  <div class="taxonomy-content">
    <div class="create-btn-container">
      @if (_taxonomiesCards().length>0) {
      @if (_showNamePopup()) {
      <div class="name-popup-container">
        Let's give taxonomy a name!
        <div class="input-container" [ngClass]="{'focused': inputFocused}">
          <input class="taxonomy-input" placeholder="Enter Name" type="text" (input)="onNameChange($event)"
            (focus)="inputFocused = true" (blur)="onTaxoBlur()">
        </div>
        @if (_taxonomyName().trim().length > 0 && !_isNameUnique()) {
        <div class="validation-error">
          This taxonomy name is unavailable. Please enter a different name. </div>
        }
        <div class="button-container">
          <button class="btn-cancel-taxonomy" (click)="handleOpenNamePopup()">
            Cancel
          </button>
          <button class="btn-proceed-taxonomy"
            [disabled]="_taxonomyName().length === 0 || isCreating() || !_isNameUnique()"
            [ngClass]="{'disabled': _taxonomyName().trim().length === 0 || isCreating() || !_isNameUnique()}"
            (click)="handleCreateTaxonomy()">
            {{ isCreating() ? 'Creating...' : 'Proceed' }}
            <img src="assets/icons/taxonomy_arrow.svg" alt="taxonomy_arrow-icon">
          </button>
        </div>
      </div>
      }
      }
    </div>
    <!-- </div> -->
    <div class="taxonomy-cards-content">
      @if (_taxonomiesCards().length>0) {
      <div class="card-collection-container">
        <ng-container *ngFor="let taxonomy of getTaxonomyCards(); let i = index">
          <taxonomy-card [taxonomy]="taxonomy"></taxonomy-card>
        </ng-container>
      </div>
      } @else {
      <div class="empty-container">
        <img src="assets/icons/taxonomy_empty_main.svg" alt="empty-taxonomy-icon">
        <div class="empty-text">
          <span class="bold">No taxonomies yet?</span>
          <span>Start by naming and creating one to organise and </span>
          <span>manage your data seamlessly! 🚀 </span>
        </div>
        <div class="empty-input-container" [ngClass]="{'focused': inputFocused}">
          <div class="input-left">
            <div class="input-title">Your First Taxonomy Name</div>
            <input class="taxonomy-input" placeholder="Type here" type="text" (input)="onNameChange($event)"
              [value]="_taxonomyName()" (focus)="inputFocused = true" (blur)="onTaxoBlur()">
            @if (_taxonomyName().trim().length > 0 && !_isNameUnique()) {
            <div class="validation-error">
              Taxonomy name already exists. Please choose a unique name.
            </div>
            }
          </div>
          <button class="btn-create-taxonomy"
            [ngClass]="{'disabled': _taxonomyName().trim().length === 0 || !_isNameUnique()}"
            [disabled]="_taxonomyName().length === 0 || !_isNameUnique()" (click)="handleEmptyStateCreate()">
            <div class="btn-text" [ngClass]="{'disabled': _taxonomyName().trim().length === 0 || !_isNameUnique()}">
              Create
            </div>
          </button>
        </div>
      </div>
      }
    </div>

  </div>
</div>

<div class="form-wrapper" *ngIf="actionsService.displayCongureForm">
  <div class="form-popup">
    <app-taxonomy-configure></app-taxonomy-configure>
  </div>
</div>
